<template>
  <div class="box">
    <!-- 整合式导航栏 -->
    <div class="navbar" :class="{ 'scrolled': isScrolled }">
      <div class="nav-content">
        <div class="logo">
          <span class="img"><img src="@/assets/logo1.png" alt="" /></span>
        </div>
        <div class="nav-links">
          <el-tabs v-model="activeName" @tab-click="handleClick" tab-position="top">
            <el-tab-pane label="首页" name="0"></el-tab-pane>
            <el-tab-pane label="产品方案" name="1"></el-tab-pane>
            <!-- <el-tab-pane label="产品服务" name="2"></el-tab-pane> -->
            <el-tab-pane label="解决方案" name="2"></el-tab-pane>
            <el-tab-pane label="优秀案例" name="3"></el-tab-pane>
            <!-- <el-tab-pane label="新闻资讯" name="5"></el-tab-pane> -->
            <el-tab-pane label="关于我们" name="4"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="contact-info">
          <span>18033068477</span>
        </div>
      </div>
    </div>
    
    <First v-if="activeName == '0' ? true : false" :point="point"></First>
    <Products v-if="activeName == '1' ? true : false" :point="point"></Products>
     <!-- <Service v-if="activeName == '2' ? true : false" ></Service> -->
    <Case v-if="activeName == '2' ? true : false" :point="point"></Case>
    <EcellentCase v-if="activeName == '3' ? true : false"></EcellentCase>
    <!-- <News v-if="activeName == '5' ? true : false"></News> -->
    <User v-if="activeName == '4' ? true : false" :point="point"></User>
  </div>
</template>

<script>
    import First from "../../components/first.vue";
    import Products from "../../components/products.vue";
    import News from "../../components/news/index.vue";
    import Service from "../../components/service.vue";
    import EcellentCase from "../../components/ecellentCase.vue";
    import User from "../../components/user.vue";
    import Case from "../../components/case.vue";

export default {
  name: "Layout",
  components: {
    First,
    Products,
    Case,
    User,
    EcellentCase,
    Service,
    News,
  },
  data() {
    return {
      show: false,
      bannerHeight: "400",
      activeName: "0",
      point:'',
      isScrolled: false  // 添加滚动状态变量
    };
  },

  mounted() {
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听（防止内存泄漏）
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleClick(tab, event) {
      console.log('切换tab',tab, event);
      this.goServe({point:'',activeName:tab.name});
      window.scrollTo({ top: 0, behavior: 'smooth' });
     // 针对锚点导航的处理
    },
    goServe(e) {
      this.point = e.point;
      console.log('this.point', this.point);
      this.activeName = e.activeName;
    },
    // 滚动处理函数
    handleScroll() {
      // 当滚动距离大于0时，设置isScrolled为true
      this.isScrolled = window.scrollY > 0;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  position: relative;
  min-width: 1600px;
  overflow: hidden;
}

/* 整合式导航栏样式 */
.navbar {
//   背景色透明度
  background: rgba(156, 156, 156, 0);
//   background: #00001c;
//   background: #000;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: background 0.3s ease;  /* 添加过渡效果 */
}
.navbar.scrolled {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background: rgba(0, 0, 0, 1);  /* 滚动时透明度1 */
}
.nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 1000px;
  padding: 0 50px;
}

.logo {
  width: 150px;
  height: 60px;
  .img {
    display: inline-block;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.nav-links {
  flex: 1;
  display: flex;
  justify-content: center;
  
   /deep/ .el-tabs__nav-wrap::after{height: 0;}
   /deep/ .el-tabs__active-bar { height: 0;}
   /deep/.el-tabs__header{margin: 0;}
  ::v-deep .el-tabs {
    border-bottom: none;
  }
  
  /deep/ .el-tabs__nav {
    border-bottom: none;
  }
  
  /deep/ .el-tabs__item {
    font-size: 18px;
    color: #fff;
    padding: 0 20px;
    margin-right: 10px;
    
    &:hover {
      color: #4bb9d5;
    }
    
    &.is-active {
      color: #4bb9d5;
      font-weight: bold;
    }
  }
  
  /deep/ .el-tabs__active-bar {
    background-color: #4bb9d5;
  }
}

.contact-info {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}
</style>